import type { TraceLineStyle, TraceLineWidth } from './types';

export const DSL_TAG_COLORS: readonly string[] = [
  '#1F77B4',
  '#D62728',
  '#2CA02C',
  '#FF7F0E',
  '#6A3D9A',
  '#17BECF',
  '#E377C2',
  '#8C564B',
  '#BCBD22',
  '#000000',
];

export const DEFAULT_LINE_STYLE: TraceLineStyle = 'solid';
export const DEFAULT_LINE_WIDTH: TraceLineWidth = 2;

export const pickTagColor = (index: number): string => {
  if (!Number.isFinite(index) || index < 0) {
    return DSL_TAG_COLORS[0];
  }
  const normalized = Math.floor(index) % DSL_TAG_COLORS.length;
  return DSL_TAG_COLORS[normalized];
};
